let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gWT2Y")).then(() => parcelRequire('7Xd97'));